import { NgModule } from '@angular/core';
import {
  DxButtonModule,
  DxContextMenuModule,
  DxDateBoxModule,
  DxFormModule,
  DxHtmlEditorModule,
  DxLoadPanelModule,
  DxNumberBoxModule,
  DxPopupModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxSpeedDialActionModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { FlexLayoutModule } from 'ngx-flexible-layout';

@NgModule({
  imports: [
    FlexLayoutModule,
    DxSpeedDialActionModule,
    DxPopupModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxButtonModule,
    DxNumberBoxModule,
    DxLoadPanelModule,
    DxFormModule,
    DxValidatorModule,
    DxDateBoxModule,
    DxContextMenuModule,
    DxScrollViewModule,
    DxHtmlEditorModule,
  ],
  exports: [
    FlexLayoutModule,
    DxSpeedDialActionModule,
    DxPopupModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxButtonModule,
    DxNumberBoxModule,
    DxFormModule,
    DxValidatorModule,
    DxLoadPanelModule,
    DxDateBoxModule,
    DxContextMenuModule,
    DxScrollViewModule,
    DxHtmlEditorModule,
  ],
})
export class SharedModule {}
